import { render, staticRenderFns } from "./FeaturedIn.vue?vue&type=template&id=1b096a28&"
var script = {}
import style0 from "./FeaturedIn.vue?vue&type=style&index=0&id=1b096a28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports